import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {
  constructor(private http: HttpClient) {}
  createDivision(payload, departmentId) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createDivision}/${departmentId}/create`,
      payload
    );
  }

  getAllDivisions() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllDivisions}`
    );
  }

  getAllDivisionsByDepartment(id){
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllDivisionsByDepartment}/${id}/all`
    );
  }

  deleteDivision(divisionId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteDivision}/${divisionId}`
    );
  }
}
